module.exports = __webpack_public_path__ + "img/gongzai.144a4a7e.jpg";